import { drawerCollapsedWidth } from "../../dashboard-constants";
import navigationBarStyles from "../../styles/dashboard-navigation-bar.css.js";

export default theme => ({
  dashboard_footer: {
    top: "auto",
    bottom: 0,
  },

  dashboard_footer__shift__closed: {
    paddingLeft: `${drawerCollapsedWidth}`,
  },

  dashboard_footer_content: {
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexFlow: "row wrap",
    margin: 3,
  },

  ...navigationBarStyles(theme),
});
